// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstAnalisisRepartoCorral = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_analisis_reparto_corral',
        name: 'analisis reparto corral',
        component: ViewLstAnalisisRepartoCorral,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
